import {cn} from '@/matic/lib/utils/cn';
import {useQueueSort, type QueueSort} from './quote-sort-store';

const OPTIONS: Array<[QueueSort, string]> = [
  ['newest', 'Newest'],
  ['oldest', 'Oldest'],
];

/** Newest | Oldest, two words wide. `dark` sits on the rail, `light` on the canvas. */
export function QueueSortToggle({
  variant = 'light',
}: {
  variant?: 'light' | 'dark';
}) {
  const sort = useQueueSort((state) => state.sort);
  const setSort = useQueueSort((state) => state.setSort);
  const dark = variant === 'dark';
  return (
    <div
      role="radiogroup"
      aria-label="Sort the queue"
      className={cn(
        'flex rounded-md p-0.5 text-[10.5px] font-semibold uppercase tracking-wide',
        dark
          ? 'bg-white/10'
          : 'border border-neutral-200 bg-white text-[11px] normal-case tracking-normal'
      )}
    >
      {OPTIONS.map(([value, label]) => {
        const active = sort === value;
        return (
          <button
            key={value}
            type="button"
            role="radio"
            aria-checked={active}
            onClick={() => {
              setSort(value);
            }}
            className={cn(
              'rounded px-1.5 py-0.5 transition-colors',
              dark
                ? active
                  ? 'bg-neutral-100 text-sidebar-bg'
                  : 'text-white/60 hover:text-white'
                : active
                  ? 'bg-neutral-900 text-white'
                  : 'text-neutral-500 hover:text-neutral-900'
            )}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
}
